/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { StyledFlexContainer } from '../StyledFlexContainer';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledMessageWithIcon = StyledFlexContainer.extend`
  align-items: center;
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledMessageWithIcon/index.js